
const state = {
    reportItemList: [],
    listcount: 0
};

export default state;
